import React from 'react';
import PropTypes from 'prop-types';
import style from './QuickCheckPopup.module.scss';

export default function QuickCheckPopup({ setShowFeedbackOptionModal, checkDetails, setShowTicketModal }) {
  const options = [
    {
      text: 'Finance approved date available',
      icon: true,
      checkIcon: !!checkDetails?.instrumentDetails?.accountsRecievedDate,
    },
    {
      text: '4 working days passed since approved',
      icon: true,
      checkIcon: !!checkDetails?.instrumentDetails?.accountsRecievedDatePlus4,
    },
    {
      text: 'JDMart Eligible',
      icon: true,
      checkIcon: checkDetails?.jdmartEligible === 'Eligible',
    },
  ];

  const allChecksPassed = options.every((option) => option.checkIcon);

  return (
    <>
      <section className={`modal ${style.Modal}`}>
        <div className={`${style.Content} modal_content fadeInUpTop `}>
          <div className="modal_header pl-20 pr-20 pt-10" style={{ paddingLeft: '35px' }}>
            <div className={`${style.HeadCenter} modal_head_center font18 fw600 color111`}>Quick Check</div>
            <div className={`${style.HeadRight} modal_head_right`}>
              <div
                className={`${style.HeadClose} modal_close icon`}
                onClick={() => setShowFeedbackOptionModal(false)}
              />
            </div>
          </div>
          <div className="modal_body p-30 pt-0">
            <ul className={`${style.table__row}`}>
              {options.map((each, i) => (
                <li className={`${style.table__item}`} data-label="column_1" key={i}>
                  <div className={`${style.item}`}>
                    <div className={`csicon ${each.checkIcon ? style.tick : style.cross}`} />
                    <div className={`${style.item} `}>{each.text}</div>
                  </div>
                </li>
              ))}
            </ul>
            {allChecksPassed ? (
              <div className={style.met}>The required criteria have been met.</div>
            ) : (
              <div className={style.notMet}>Ticket cannot be created as criteria were not met.</div>
            )}
            <div className={`${style.BtnGroup} mt-20`}>
              <button
                className={`${style.Button} bluefill_animate font16 fw500 colorFFF`}
                style={{
                  background: !allChecksPassed && 'gray',
                  cursor: !allChecksPassed && 'not-allowed',
                }}
                onClick={() => {
                  if (!allChecksPassed) return;
                  setShowTicketModal(true);
                  setShowFeedbackOptionModal(false);
                }}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
QuickCheckPopup.propTypes = {
  setShowFeedbackOptionModal: PropTypes.func,
  checkDetails: PropTypes.object,
  setShowTicketModal: PropTypes.func,
};
